import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import { map, tap, last } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class DeleterService {
  public progressSource = new BehaviorSubject<number>(0);

  constructor(private http: HttpClient) {}

  delete(fileName: String, token: String) {
    // Extract just the blob name from the full Azure URL if needed
    // e.g. "https://storage.blob.core.windows.net/adjuntos/67e55a8.png" → "67e55a8.png"
    let blobName = fileName.toString();
    const lastSlash = blobName.lastIndexOf('/');
    if (lastSlash !== -1) {
      blobName = blobName.substring(lastSlash + 1);
    }

    const reqHeader = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.post(
      `${environment.API_URL}/delete-file?fileName=${encodeURIComponent(blobName)}`,
      null,
      { headers: reqHeader }
    ).pipe(
      map((body: any) => {
        if (body && body.success) {
          return body.filename;
        }
        return null;
      }),
      tap((result: any) => this.processProgress(result)),
      last()
    );
  }

  processProgress(envelope: any): void {
    if (typeof envelope === "number") {
      this.progressSource.next(envelope);
    }
  }

}
